<!--
@Create By Tim For 19/08/14
@课程列表
-->
<template>
  <div class="CourseList">
    <el-row
      :gutter="20"
      style="min-height: 500px;"
    >
      <el-col
        :span="4"
        v-for="(item, index) in courseData"
        :key="index"
      >
        <a
          href="javascript:;"
          @click='goToInfo(item)'
        >
          <el-card
            class="box-card"
            shadow="hover"
          >
            <div class="cardImg">
              <el-image
                fit="fill"
                :lazy="true"
                style="width:221px;height:140px;"
                :src="item.coursePicUrl"
              >
                <div
                  slot="placeholder"
                  class="placeholder"
                >
                  封面加载中...
                </div>
              </el-image>
            </div>
            <p class="title">{{ item.courseName }}</p>
            <p class="tip">{{ grade(item.courseGrade) }} | {{ item.chapterCount }}节课</p>
          </el-card>
        </a>
      </el-col>

      <!-- 暂无数据 -->
      <div
        class="dataNull"
        v-if="!pagination"
      >
        未查询到相关内容
      </div>
    </el-row>

    <!-- 课程分页组件 -->
    <div
      class="pagination"
      v-if="pagination"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totals"
        @current-change="currentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
      >
      </el-pagination>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import Bus from '../../bus'
import api from '../../../config/api'

export default {
  name: 'CourseList',
  props: ['courseID'],
  data() {
    return {
      // 是否显示分页
      pagination: false,
      // 课程列表集合
      courseData: [],
      // 当前页
      currentPage: 1,
      // 每页显示几条
      pageSize: 24,
      // 数据总条数
      totals: 0,
      courseName: '',
    }
  },

  created() {

  },

  mounted() {
    this.getCourseList()
  },

  methods: {
    // 获取课程列表
    getCourseList() {
      this.$axios.get(
        api + 'cources/query/search?categoryId=' + this.courseID + '&current=' + this.currentPage + '&limit=' + this.pageSize + '&courseName=' + this.courseName
      ).then(res => {
        if (res.records) {
          this.pagination = true
          this.courseData = res.records
          this.totals = res.total
        } else {
          this.pagination = false
          this.courseData = []
        }
      })
    },

    // 过滤课程级别
    grade(data) {
      if (data === 1) {
        return '初级'
      } else if (data === 2) {
        return '中级'
      } else if (data === 3) {
        return '高级'
      }
    },

    // 点击页码
    currentChange(val) {
      this.currentPage = val
      this.getCourseList()
    },

    // 点击上一页
    prevClick(val) {
      this.getCourseList()
    },

    // 点击下一页
    nextClick(val) {
      this.getCourseList()
    },

    // 进入详情页
    goToInfo(data) {
      this.$router.push({ path: '/CourseInfo/' + data.id })
    },


  },

  watch: {

  },



}
</script>

<style>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

.CourseList .el-card__body {
  padding: 0;
}
</style>

<style scoped>
.CourseList {
  width: 1440px;
  margin: 0 auto;
}

.CourseList .box-card {
  margin-bottom: 20px;
}

.CourseList .cardImg {
  width: 221px;
  height: 140px;
}

.CourseList .cardImg img {
  width: 221px;
  height: 140px;
}

.CourseList .title {
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
  font-size: 14px;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.CourseList .tip {
  height: 20px;
  padding: 0 5px;
  line-height: 20px;
  font-size: 13px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 8px;
}

.CourseList .pagination {
  margin: 20px 0;
  text-align: center;
}

.CourseList .placeholder {
  width: 221px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}

.CourseList .dataNull {
  height: 300px;
  width: 100%;
  line-height: 300px;
  font-size: 16px;
  text-align: center;
  color: #666;
}

.CourseList a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AllCourse/CourseList.vue